import React from 'react';

import cx from 'classnames';

import { Skeleton } from '../Skeleton';

import { IconProps } from './Icon.types';

/**
 * Used to insert an SVG icon into other components.
 */
const Icon = ({ className, hasAriaHidden = true, id, isLoading = false }: IconProps) => {
  const iconClassNames = cx('c-icon', className);

  if (isLoading) return <Skeleton additionalClassNames={iconClassNames} circle />;

  return (
    <svg aria-hidden={hasAriaHidden} className={iconClassNames} data-testid={`qa-icon-${id}`} focusable="false">
      <use data-testid="qa-icon-use" xlinkHref={`#${id}`} />
    </svg>
  );
};

export { Icon };
